"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var CircularProgress = function (_a) {
    var classes = _a.classes, _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.disableShrink, disableShrink = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 40 : _d, _e = _a.thickness, thickness = _e === void 0 ? 3.6 : _e, _f = _a.value, value = _f === void 0 ? 0 : _f, _g = _a.variant, variant = _g === void 0 ? 'indeterminate' : _g;
    return (react_1.default.createElement(CircularProgress_1.default, { classes: classes, color: color, disableShrink: disableShrink, size: size, thickness: thickness, value: value, variant: variant }));
};
exports.default = CircularProgress;
